export const getEmailContentTemplates = (ctx) => {
  const ev = ctx || {};
  const date = ev.date || ev.startDate || '';
  const time = ev.time || ev.startTime || '';
  const vol = ev.volume ? `Vol.${ev.volume}` : '';
  const theme = ev.theme || '';
  const eventLine = [vol, theme].filter(Boolean).join(' • ');
  const whenLine = [date, time].filter(Boolean).join(' ');
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://crapule.xyz';
  const ctaHref = `${origin}/`;
  const ctaStyle = 'display:inline-block;padding:10px 16px;border-radius:6px;background:#111;color:#fff;text-decoration:none;border:1px solid #222;font-weight:600';
  const sectionTitleStyle = 'margin:0 0 8px 0;font-size:16px;font-weight:700';
  const smallStyle = 'color:#666;font-size:12px';
  return [
    {
      id: 'next-event-info',
      label: 'Infos prochain événement',
      render: () =>
        `<p>Bonjour,</p>
<h3 style="${sectionTitleStyle}">Prochain événement</h3>
<p>${eventLine ? `<strong>${eventLine}</strong>` : 'Notre prochain événement'}${whenLine ? ` • ${whenLine}` : ''}</p>
<p>Lieu: Crapule Bruxelles</p>
<p>Au programme: musique, food & vibes.</p>
<p><a href="${ctaHref}" style="${ctaStyle}">Découvrir et réserver</a></p>
<p style="${smallStyle}">Si le bouton ne s’affiche pas, copiez ce lien: ${ctaHref}</p>
<p>À bientôt,<br/>Crapule</p>`,
    },
    {
      id: 'booking-confirmed',
      label: 'Réservation confirmée',
      render: () =>
        `<p>Bonjour,</p>
<h3 style="${sectionTitleStyle}">Réservation confirmée</h3>
<p>Votre réservation est <strong>confirmée</strong>.</p>
${eventLine ? `<p>Événement: <strong>${eventLine}</strong>.</p>` : ''}
${whenLine ? `<p>Date et heure: <strong>${whenLine}</strong>.</p>` : ''}
<p>Adresse: Crapule Bruxelles</p>
<p>Merci de vous présenter 10 minutes avant le début.</p>
<p><a href="${ctaHref}" style="${ctaStyle}">Voir les détails</a></p>
<p style="${smallStyle}">Besoin de modifier ou annuler ? Répondez à cet email.</p>
<p>Crapule</p>`,
    },
    {
      id: 'booking-updated',
      label: 'Statut de réservation mis à jour',
      render: () =>
        `<p>Bonjour,</p>
<h3 style="${sectionTitleStyle}">Mise à jour de votre réservation</h3>
<p>Le statut de votre réservation a été <strong>mis à jour</strong>.</p>
${eventLine ? `<p>Événement: <strong>${eventLine}</strong>.</p>` : ''}
<p>Si vous avez des questions, répondez directement à cet email.</p>
<p><a href="${ctaHref}" style="${ctaStyle}">Consulter les informations</a></p>
<p>Crapule</p>`,
    },
    {
      id: 'newsletter',
      label: 'Newsletter',
      render: () =>
        `<p>Bonjour,</p>
<h3 style="${sectionTitleStyle}">Nos actualités</h3>
<p>Au menu ce mois-ci:</p>
<ul>
  <li>Nouveaux événements et line-up</li>
  <li>Menu & nouveautés food</li>
  <li>Moments et photos</li>
</ul>
<p><a href="${ctaHref}" style="${ctaStyle}">Tout découvrir</a></p>
<p style="${smallStyle}">Suivez-nous sur Instagram pour ne rien manquer.</p>
<p>Merci et à bientôt,<br/>Crapule</p>`,
    },
    {
      id: 'booking-canceled',
      label: 'Réservation annulée',
      render: () =>
        `<p>Bonjour,</p>
<h3 style="${sectionTitleStyle}">Réservation annulée</h3>
<p>Votre réservation a été <strong>annulée</strong>.</p>
${eventLine ? `<p>Concernant: <strong>${eventLine}</strong>.</p>` : ''}
<p>Pour reprogrammer, contactez-nous en répondant à cet email.</p>
<p><a href="${ctaHref}" style="${ctaStyle}">Voir les événements</a></p>
<p>Crapule</p>`,
    },
    {
      id: 'event-reminder',
      label: 'Rappel d’événement',
      render: () =>
        `<p>Bonjour,</p>
<h3 style="${sectionTitleStyle}">Rappel</h3>
<p>${eventLine ? `<strong>${eventLine}</strong>` : 'Notre événement'}${whenLine ? ` a lieu le <strong>${whenLine}</strong>` : ''}.</p>
<p>Adresse: Crapule Bruxelles. Ouverture des portes 30 minutes avant.</p>
<p><a href="${ctaHref}" style="${ctaStyle}">Infos pratiques</a></p>
<p>À très vite,<br/>Crapule</p>`,
    },
  ];
};

export const applyEmailContentTemplate = (id, ctx) => {
  const list = getEmailContentTemplates(ctx);
  const t = list.find(x => x.id === id);
  return t ? t.render(ctx) : '';
};
